/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// THIS FILE IS GENERATED BY BUILD TOOL
// DO NOT EDIT IT MANUAL
import { wrapIcon } from '../../wrapIcon';
import { SVGProps } from 'react';
const SvgAddNodeBase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.9275 18.1774H20.4275M18.1775 15.9274V20.4274M17.7605 13.3024C18.3124 11.7395 18.3167 10.0353 17.7726 8.46965C17.2285 6.90396 16.1684 5.56971 14.7662 4.68584C13.364 3.80197 11.7029 3.42097 10.0557 3.60538C8.40845 3.78979 6.87281 4.52864 5.70075 5.70069C4.5287 6.87275 3.78985 8.40839 3.60544 10.0556C3.42104 11.7029 3.80203 13.3639 4.6859 14.7661C5.56977 16.1683 6.90402 17.2284 8.46971 17.7725C10.0354 18.3166 11.7395 18.3124 13.3025 17.7604"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const SvgAddNode = wrapIcon(SvgAddNodeBase);
export default SvgAddNode;
